<style>
.support-index .st-body .ticket-content .ticket-description {
  height: auto;
}

.table.table-clean td .sub-value {
  color: black;
}
</style>
<template>
  <div>
    <div v-if="despachoe && despachoe.detalle">
      <div class="floated-colors-btn second-floated-btn" style="z-index: 1010 !important" @click="cambiarUiTabla">
        <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
          <div class="os-toggler-i">
            <div class="os-toggler-pill"></div>
          </div>
        </div>
        <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
        <span v-if="cambiar_UiTabla">Tabla Resumen</span>
      </div>
      <div class="row mt-2">
        <div class="col-lg-12">
          <div class="padded-lg">
            <!--START - Projects list-->
            <div v-if="!cambiar_UiTabla" class="projects-list">
              <div class="project-box" v-for="detalle in despachoe.detalle" @click="abrirModalDescripcion(detalle)"
                :key="detalle.id" v-bind:style="detalle.status_picking == 'sin_pickear'
                    ? 'background-color: #FFFFFF;'
                    : detalle.status_picking == 'pendiente_pickear'
                      ? 'background-color: #FFF7E1;'
                      : detalle.status_picking == 'sobre_pickeado'
                      ? 'background-color: #1216D4;'
                      : detalle.status_picking == 'pickeo_finalizado'
                        ? 'background-color: #E2FFD5;'
                        : detalle.status_picking == 'sin_existencia'
                          ? 'background-color: #FFECEC;'
                          : 'color: #929292;'
                  ">
                <div class="project-info text-center" style="padding-left: 1em">
                  <div class="project-title">
                    <div class="badge badge-warning" v-if="detalle.status_picking == 'sin_pickear'">
                      SIN PICKEAR
                    </div>
                    <div class="badge badge-light" v-if="detalle.status_picking == 'pendiente_pickear'">
                      CANTIDAD PENDIENTE PICKEAR
                    </div>
                    <div class="badge badge-blue" v-if="detalle.status_picking == 'sobre_pickeado'">
                      SOBRE PICKEADO
                    </div>
                    <div class="badge badge-success" v-if="detalle.status_picking == 'pickeo_finalizado'">
                      TOTALMENTE PICKEADO
                    </div>
                    <div class="badge badge-danger" v-if="detalle.status_picking == 'sin_existencia'">
                      SIN EXISTENCIA
                    </div>
                    <h5>
                      {{ detalle.producto_obj.sku }}
                    </h5>
                    <small>{{ detalle.producto_obj.nombre }}</small>
                  </div>
                  <div class="badge badge-info" v-if="detalle.producto_obj.categoria">
                    {{ detalle.producto_obj.categoria.nombre }}
                  </div>
                </div>
                <div class="row col-12">
                  <div class="badge badge-default" v-for="_barra in detalle.producto_obj.barras" :key="_barra">
                    {{ _barra }}
                  </div>
                </div>
                <hr />
                <div class="project-info">
                  <div class="row align-items-center">
                    <div class="col-sm-5">
                      <div class="row">
                        <div class="col-6">
                          <div class="el-tablo highlight">
                            <div class="label">Solicitada</div>
                            <h5 style="color: #30bf19">
                              {{ detalle.cantidad_solicitada }}
                            </h5>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="el-tablo highlight">
                            <div class="label">Pickear</div>
                            <h5 style="color: #30bf19">
                              {{ detalle.pendiente_pickear }}
                            </h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="el-tablo highlight">
                            <div class="label">Pickeado</div>
                            <div>
                              {{ detalle.cant_pickeada }}
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="el-tablo highlight">
                            <div class="label">Carrito</div>
                            <div>
                              {{ detalle.cant_actual_en_carrito }}
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="el-tablo highlight">
                            <div class="label">Estacionada</div>
                            <div>
                              {{ detalle.cant_asignada_estacion }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-5 offset-sm-2">
                      <div class="os-progress-bar primary">
                        <div class="bar-labels">
                          <div class="bar-label-left">
                            <span>Pickeado:</span>
                          </div>
                          <div class="bar-label-right col-10">
                            <div class="progress">
                              <div class="
                                  progress-bar progress-bar-striped
                                  bg-success
                                  progress-bar-animated
                                " role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{
                                  width: detalle.porc_pickeado + '%',
                                }">
                                <a style="color: black">{{ detalle.porc_pickeado }}%</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="os-progress-bar primary">
                        <div class="bar-labels">
                          <div class="bar-label-left">
                            <span>Estacionado:</span>
                          </div>
                          <div class="bar-label-right col-9">
                            <div class="progress">
                              <div class="
                                  progress-bar progress-bar-striped
                                  bg-success
                                  progress-bar-animated
                                " role="progressbar" :style="{
                                  width: detalle.porc_asignada_estacion + '%',
                                }">
                                <a style="color: black">{{ detalle.porc_asignada_estacion }}%</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--END - Projects list-->
            <div class="table-responsive" v-if="cambiar_UiTabla">
              <!-------------------- Tabla de REsultados -------------------->
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="det in despachoe.detalle" v-bind:key="det.id">
                    <td v-bind:style="det.status_picking == 'sin_pickear'
                        ? 'background-color: #FFFFFF;'
                        : det.status_picking == 'pendiente_pickear'
                          ? 'background-color: #FEEBB9;'
                        : det.status_picking == 'sobre_pickeado'
                          ? 'background-color: #1216D4;'
                          : det.status_picking == 'pickeo_finalizado'
                            ? 'background-color: #d3ffbf;'
                            : det.status_picking == 'sin_existencia'
                              ? 'background-color: #f7cdcd;'
                              : 'color: #929292;'
                      ">
                      <div class="value">
                        <small class="font-weight-bold">{{
                          det.producto_obj.sku
                        }}</small>
                      </div>
                      <small>
                        <div class="value">
                          {{ det.producto_obj.nombre }}
                        </div>
                      </small>
                      Pickeada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cant_pickeada }}
                        <i v-if="det.cant_pickeada == det.cantidad_solicitada" class="fas fa-check"></i>
                      </span>
                    </td>
                    <td v-bind:style="det.status_picking == 'sin_pickear'
                        ? 'background-color: #FFFFFF;'
                        : det.status_picking == 'pendiente_pickear'
                          ? 'background-color: #FFF7E1;'
                        : det.status_picking == 'sobre_pickeado'
                          ? 'background-color: #1216D4;'
                          : det.status_picking == 'pickeo_finalizado'
                            ? 'background-color: #E2FFD5;'
                            : det.status_picking == 'sin_existencia'
                              ? 'background-color: #FFECEC;'
                              : 'color: #929292;'
                      ">
                      <div class="badge badge-info" v-if="det.producto_obj.categoria">
                        {{ det.producto_obj.categoria.nombre }}
                      </div>
                      <br />
                      Solicitada:
                      <span class="sub-value font-weight-bold" style="color: blue">
                        {{ det.cantidad_solicitada }}
                      </span>

                      <br />
                      Estacionada:
                      <span class="sub-value font-weight-bold text-success">
                        {{ det.cant_asignada_estacion }}
                        <i v-if="det.cant_pickeada == det.cant_asignada_estacion &&
                          det.cant_asignada_estacion > 0
                          " class="fas fa-check"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DescripcionDespachoModalComponent :existencia="existencia" :detalle="detalle" :current="despachoe"
      @refresh="refresh_tarea()" />
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import DescripcionDespachoModalComponent from "@/components/wms/despachos/DescripcionDespachoModalComponent";

export default {
  components: { DescripcionDespachoModalComponent },
  data() {
    return {
      cambiar_UiTabla: false,
      existencia: "",
      detalle: {},
    };
  },
  props: ["despachoe"],
  computed: {},
  mounted() { },
  methods: {
    abrirModalDescripcion(detalle) {
      this.detalle = detalle;
      if (this.despachoe.estado == "A") {
        this.existenciaProductoTienda(this.detalle.producto);
        $("#descripcionModal").modal("show");
      }
    },
    existenciaProductoTienda(producto) {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        producto,
        "existencia_producto_tienda_no_calculada",
        {
          tienda: self.despachoe.tienda.codigo,
        }
      )
        .then((response) => {
          self.existencia = response.data.cantidad;
        })
        .catch((error) => {
          alert("error");
        });
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
  },
};
</script>
